import React, { Component } from 'react';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import FontAwesome from 'react-fontawesome';
// import malmabLogo from '../../static/malmab.png';
// import modLogo from '../../static/mod.png';
// import styles from './Header.css';

class Header extends Component{

  constructor(props) {
    super(props);
  }

  render(){
    return(
        <div className="header-background">
          {this.props.init.user ? 
          <div className="header-content">
            <h1>מערכת זקיף</h1>
            <h4>להגשת מועמדות לסיווג ביטחוני בדרגה 5-6.</h4>
          </div>
          : null}

          {this.props.init.candidate && this.props.validSms ? 
          <div className="header-content">
            <h1>מערכת זקיף</h1>
            <h4>להגשת מועמדות לסיווג ביטחוני בדרגה 5-6.</h4>
          </div> 
          :null }

          {this.props.init.admin ? 
          <div className="header-content">
            <h1>מערכת זקיף</h1>
            <h4>להגשת מועמדות לסיווג ביטחוני בדרגה 5-6.</h4>
          </div> 
          :null }
          
        </div>
    );
  };
}

export default Header;